module.exports = __webpack_public_path__ + "img/fruit_mulberry.4e4024c4.png";